export const steps = [
    {
        target: '.type-selector-guide',
        title: 'decal.guided-tour.type.title',
        content: 'decal.guided-tour.type.content',
        position: 'right',
        waitForClick: true,
        needsToBeOpened: false,
        stepType: 'Type',
    },
    {
        target: '.type-selector-dialog-guide',
        title: 'decal.guided-tour.type-selection.title',
        content: 'decal.guided-tour.type-selection.content',
        position: 'left',
        waitForClick: false,
        needsToBeOpened: true,
        stepType: 'Type',
    },
    {
        target: '.form-selector-guide',
        title: 'decal.guided-tour.shape.title',
        content: 'decal.guided-tour.shape.content',
        position: 'right',
        waitForClick: true,
        needsToBeOpened: false,
        stepType: 'Form',
    },
    {
        target: '.form-selector-content-guide',
        title: 'decal.guided-tour.shape-selection.title',
        content: 'decal.guided-tour.shape-selection.content',
        position: 'right',
        waitForClick: false,
        needsToBeOpened: true,
        stepType: 'Form',
    },
    // {
    //   target: '.hole-selector-content-guide',
    //   title: 'Välj hål placering',
    //   content:
    //     'Börja med att välja vilken typ av skylt du vill skapa. Klicka på Typ-ikonen.',
    //   position: 'right' as const,
    //   waitForClick: false,
    //   needsToBeOpened: true,
    //   stepType: 'Form',
    // },
    {
        target: '.size-selector-guide',
        title: 'decal.guided-tour.size.title',
        content: 'decal.guided-tour.size.content',
        position: 'right',
        waitForClick: true,
        needsToBeOpened: false,
        stepType: 'Size',
    },
    {
        target: '.size-selector-content-guide',
        title: 'decal.guided-tour.size-selection.title',
        content: 'decal.guided-tour.size-selection.content',
        position: 'right',
        waitForClick: false,
        needsToBeOpened: true,
        stepType: 'Size',
    },
    {
        target: '.background-selector-guide',
        title: 'decal.guided-tour.backgroundcolor.title',
        content: 'decal.guided-tour.backgroundcolor.content',
        position: 'right',
        waitForClick: true,
        needsToBeOpened: false,
        stepType: 'Background',
    },
    {
        target: '.background-selector-content-guide',
        title: 'decal.guided-tour.backgroundcolor-selection.title',
        content: 'decal.guided-tour.backgroundcolor-selection.content',
        position: 'right',
        waitForClick: false,
        needsToBeOpened: true,
        stepType: 'Background',
    },
    {
        target: '.text-button-guide',
        title: 'decal.guided-tour.text.title',
        content: 'decal.guided-tour.text.content',
        position: 'right',
        waitForClick: true,
        needsToBeOpened: false,
        stepType: 'Text',
    },
    {
        target: '.text-selector-content-guide',
        title: 'decal.guided-tour.text-selection.title',
        content: 'decal.guided-tour.text-selection.content',
        position: 'right',
        waitForClick: true,
        needsToBeOpened: true,
        stepType: 'Text',
    },
    {
        target: '.selected-object-menu-guide',
        title: 'decal.guided-tour.text-menu.title',
        content: 'decal.guided-tour.text-menu.content',
        position: 'top',
        waitForClick: false,
        needsToBeOpened: true,
        stepType: 'Text',
    },
    {
        target: '.image-button-guide',
        title: 'decal.guided-tour.image.title',
        content: 'decal.guided-tour.image.content',
        position: 'right',
        waitForClick: true,
        needsToBeOpened: false,
        stepType: 'Image',
    },
    {
        target: '.image-selector-dialog-guide',
        title: 'decal.guided-tour.image-selection.title',
        content: 'decal.guided-tour.image-selection.content',
        position: 'left',
        waitForClick: false,
        needsToBeOpened: true,
        stepType: 'Image',
    },
    {
        target: '.canvas-wrapper-guide',
        title: 'decal.guided-tour.canvas-summary.title',
        content: "decal.guided-tour.canvas-summary.content",
        position: 'bottom',
        waitForClick: false,
        needsToBeOpened: false,
        stepType: 'All',
    },
];
